import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { DiagnosisCard } from '../../../components/Diagnosis/DiagnosisCard'
import { HeaderPage } from '../../../components/HeaderPage'
import { SpinnerLoad } from '../../../components/Loading/SpinnerLoad'
import useApi from '../../../hooks/useApi'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import { AdminLayout } from '../../../layout/AdminLayout'
import { Diagnosis as DIagnosisType} from '../../../types/Diagnosis'

export const Diagnosis = () => {

    const api = useApi();

    const [diagnoses,setDiagnoses] = useState<DIagnosisType[]>([])
    const [load,setLoad] = useState<boolean>(false)

    const loadDiagnosis = useCallback(async () => {
        setLoad(true)
        await api.get('/admin/diagnoses').then( res => {
            setDiagnoses(res.data)
        }).catch(console.log)
        setLoad(false)
    },[api,setLoad])

    useEffect(()=>{
        loadDiagnosis()
    },[loadDiagnosis])

    return (
        <AdminLayout>
                <HeaderPage name="Testes" button={
                      <Link className='mb-3' to={'/admin/testes/novo'}><Button value={"Novo teste"} /></Link>
                } />
            {load && <SpinnerLoad/>}
            <div className='grid grid-cols-3 gap-x-12  gap-y-4'>
            {diagnoses.map(item => (
                <div key={item.id}>
                <DiagnosisCard diagnosis={item} />
                </div>
            ))}
            </div>
        </AdminLayout>
    )
}
